import { Component, ViewChild } from '@angular/core';
import { MenuController, NavController, Slides } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { TabsPage } from '../tabs/tabs';

declare var dataLayer: Array<any>;

@Component({
  selector: 'page-tutorial',
  templateUrl: 'tutorial.html'
})

export class TutorialPage {
  showSkip = true;

	@ViewChild('slides') slides: Slides;

  constructor(
    public navCtrl: NavController,
    public menu: MenuController,
    public storage: Storage
  ) { }

  startApp() {
    this.navCtrl.push(TabsPage).then(() => {
      this.storage.set('hasSeenTutorial', 'true');
    })
  }

  onSlideChangeStart(slider: Slides) {
    this.showSkip = !slider.isEnd();
  }

	ionViewWillEnter() {
		this.slides.update();
	}

  ionViewDidEnter() {
    // the root left menu should be disabled on the tutorial page
    this.menu.enable(false);
    dataLayer.push({
      'appEventCategory': 'tutorial',
      'appEventAction': 'Tutorial shown',
      'appEventLabel': 'Tutorial button'
    });
    dataLayer.push({'event': 'appEvent'});
  }

  ionViewDidLeave() {
    // enable the root left menu when leaving the tutorial page
    this.menu.enable(true);

  }

  ionViewDidLoad() {
    dataLayer.push({
      'screenPath': 'tutorial',
      'screenName': 'TutorialPage'
    });

    dataLayer.push({'event': 'appScreenView'});
  }
}



// WEBPACK FOOTER //
// ./src/pages/tutorial/tutorial.ts